export default __webpack_public_path__ + "media/color/mcap-b352f84b.svg";